import React, { useEffect, useState } from 'react'
import DataSource from '../DataSource'
import PropTypes from 'prop-types'

const SpeedBoostAvailableBoostDays = ({ scheduleData, boostDaysRate }) => {
    const { boostBankDays, boostMonthDays, broadbandServiceId } = scheduleData
    const [nextBillingCycleStart, setNextBillingCycleStart] = useState(null)

    useEffect(() => {
        if (broadbandServiceId) {
            DataSource.getData(`/api/getService/broadband/${broadbandServiceId}`, response => {
                setNextBillingCycleStart(response.serviceDetails.nextBillingCycleStart)
            }, error => {
                console.log(error)
                setNextBillingCycleStart(null)
            })
        }
    }, [broadbandServiceId])

    return (
        <React.Fragment>
            <div className='speed-boost-days-container text-center'>
                <h2 className='color-indigo'>AVAILABLE SPEED UPGRADE DAYS</h2>
                <p className='text-left lh'>
                    Your <span className='bold color-indigo'>Speed Upgrade Days</span> will be
                    consumed in the following order. You can add days from each
                    category together to extend the length of your{' '}
                    <span className='bold color-indigo'>My Speed Boost™</span> upgrade.
                </p>
                <form className='speed-boost-form' onSubmit={(e) => e.preventDefault()}>
                    <div className='row mt-3 mt-lg-5 p-3'>
                        <div className='form-control boost-days justify-content-between'>
                            <label htmlFor='startTime'>
                                <span className='bold color-indigo'>
                                    FREE Monthly Speed Upgrade Days
                                </span>
                                <br />
                                {nextBillingCycleStart && <span className='font-xsmall'>
                                    (will rollover to Boost Bank {nextBillingCycleStart})
                                </span>}
                            </label>
                            <input
                                id='boostDaysNeeded'
                                type='text'
                                name='boostDaysNeeded'
                                value={`${boostMonthDays} days available` || ''}
                                className='bg-lightgrey'
                                disabled
                            />
                        </div>
                        <div className='form-control mt-md-4 mt-3 boost-days justify-content-between'>
                            <label htmlFor='startTime'>
                                <span className='bold color-indigo'>
                                    My Speed Boost Bank
                                </span>
                                <br />
                                <span className='font-xsmall'>
                                    FREE Bonus Days (Max 30)
                                </span>
                            </label>
                            <input
                                id='boostBankDays'
                                type='text'
                                name='boostBankDays'
                                value={`${boostBankDays} days available` || ''}
                                className='bg-lightgrey'
                                disabled
                            />
                        </div>
                        <div className='form-control mt-md-4 mt-3 boost-days justify-content-between'>
                            <label htmlFor='startTime'>
                                <span className='bold color-indigo'>
                                    Purchased Speed Upgrade Days
                                </span>
                                <br />
                                <span className='font-xsmall'>
                                    (Max per purchase 30 days)
                                </span>
                            </label>
                            <input
                                id='boostDaysRate'
                                type='text'
                                name='boostDaysRate'
                                value={boostDaysRate || ''}
                                className='bg-lightgrey'
                                disabled
                            />
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    )
}

SpeedBoostAvailableBoostDays.propTypes = {
    boostBankDays: PropTypes.number.isRequired,
    boostDaysNeeded: PropTypes.number.isRequired,
    boostDaysRate: PropTypes.string.isRequired
}

SpeedBoostAvailableBoostDays.defaultProps = {
    boostBankDays: 0,
    boostDaysNeeded: 0,
    boostDaysRate: '$2/day'
}

export default SpeedBoostAvailableBoostDays



// WEBPACK FOOTER //
// ./resources/js/modules/SpeedBoostAvailableBoostDays.js